import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

import { clsx } from 'clsx';
import Link from 'next/link';

import { ICON_SECONDARY } from '@shared/constants/colors';
import { ROUTES } from '@shared/constants/routes';

import cls from './Dropdown.module.scss';

export const Dropdown = () => {
  const [hovered, setHovered] = useState(false);

  const mouseOn = () => {
    setHovered(true);
  };

  const mouseLeave = () => {
    setHovered(false);
  };

  return (
    <div
      data-testid={'dropdown'}
      onMouseEnter={mouseOn}
      onMouseLeave={mouseLeave}
      className={clsx(cls.wrap, { [cls.hovered]: hovered })}
    >
      <div className={cls.label}>
        Для покупателей
        <ChevronDown
          size={14}
          color={ICON_SECONDARY}
        />
      </div>
      <div
        data-testid={'dropdown-overlay'}
        className={cls.overlay}
      >
        <div className={cls.options}>
          <div className={cls.item}>
            <Link
              className={cls.link}
              href={ROUTES.DELIVERY_AND_PAYMENT}
            >
              Доставка и оплата
            </Link>
          </div>
          <div className={cls.item}>
            <Link
              className={cls.link}
              href={ROUTES.WARRANTY}
            >
              Гарантия
            </Link>
          </div>
          <div className={cls.item}>
            <Link
              className={cls.link}
              href={ROUTES.EXPLOITATION}
            >
              Эксплуатация
            </Link>
          </div>
          <div className={cls.item}>
            <Link
              className={cls.link}
              href={ROUTES.BLOG}
            >
              Полезные статьи
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
